import { Component } from '@angular/core';
import { ChequeRemittanceService } from '../../../../../../shared/store/cheque-remittance/cheque-remittance.service';
import { Observable } from 'rxjs';
import { ChequeRemittanceModel } from '../../../../../../shared/store/cheque-remittance/types';
import { ButtonType } from '../../../../../../shared/store/subheader/type';
import { AccountMoveStatus } from '../../../../../../shared/store/accounting/types';
import { filterTrue } from '../../../../../../shared/pipe/rxjs/operators';
import { filter, take } from 'rxjs/operators';
import { AccountingService } from '../../../../../../shared/store/accounting/accounting.service';

@Component({
  selector: 'app-cheque-remittance-details-account-moves',
  standalone: false,
  templateUrl: './cheque-remittance-details-account-moves.component.html',
  styleUrl: './cheque-remittance-details-account-moves.component.scss',
})
export class ChequeRemittanceDetailsAccountMovesComponent {
  chequeRemittanceModel$: Observable<ChequeRemittanceModel>;

  protected readonly ButtonType = ButtonType;

  constructor(
    private readonly chequeRemittanceService: ChequeRemittanceService,
    private readonly accountingService: AccountingService,
  ) {
    this.chequeRemittanceModel$ = this.chequeRemittanceService.getById.value$;
  }

  triggerAction(
    actionName: string,
    accountMoveId: number,
    chequeRemittanceId: number,
  ) {
    let status: AccountMoveStatus = 'Draft';
    switch (actionName) {
      case 'CancelAccountMove':
        status = 'Cancel';
        this.onClickChangeAccountMoveStatus(
          accountMoveId,
          status,
          chequeRemittanceId,
        );
        break;
      case 'ValidateAccountMove':
        status = 'Posted';
        this.onClickChangeAccountMoveStatus(
          accountMoveId,
          status,
          chequeRemittanceId,
        );
        break;
      case 'InvalidateAccountMove':
        status = 'Draft';
        this.onClickChangeAccountMoveStatus(
          accountMoveId,
          status,
          chequeRemittanceId,
        );
        break;
      // case 'DeleteAccountMove':
      //   this.onClickDeleteAccountMove(accountMoveId, contactId);
      //   break;
    }
  }

  onClickChangeAccountMoveStatus(
    id: number,
    status: AccountMoveStatus,
    chequeRemittanceId: number,
  ) {
    let result$ = this.accountingService.changeAccountMoveStatus.call({
      id: id.toString(),
      status: status,
    });

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.chequeRemittanceService.getById.call(chequeRemittanceId.toString());
      this.accountingService.changeAccountMoveStatus.reset();
    });
  }

  // onClickDeleteAccountMove(id: number, chequeRemittanceId: number) {
  //   let result$ = this.accountingService.delete.call(id);
  //
  //   result$.pipe(filterTrue(), take(1)).subscribe((result) => {
  //     this.chequeRemittanceService.getById.call(chequeRemittanceId.toString());
  //     this.accountingService.delete.reset();
  //   });
  // }
}
